export { AngryBirdGameCoreModule } from './angry-bird-game-core.module';
export { AngryBirdGameSelectorComponent } from './angry-bird-game-selector/angry-bird-game-selector.component';
export { AngryBirdGameCoreService } from './angry-bird-game-core.service';
export { IAngryBirdGame } from './angry-bird-game.interface';
